require('./src/styles/ng-notify.css');
require('./src/scripts/ng-notify.js');
module.exports = 'uiSwitch';



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-notify/index.js
 ** module id = 655
 ** module chunks = 1
 **/